import { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { PrivateRoute } from './PrivateRoute'
import { PublicRoute } from './PublicRoute'
import { AdminRoute } from './AdminRoute'
import { privateRoutes, publicRoutes, adminRoutes } from './routes'
import { Loading } from '@/components/ui/loading'

export function Router() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* Rotas Públicas */}
        <Route element={<PublicRoute />}>
          {publicRoutes.map(({ path, component: Component }) => (
            <Route
              key={path}
              path={path}
              element={
                <Suspense fallback={<Loading />}>
                  <Component />
                </Suspense>
              }
            />
          ))}
        </Route>

        {/* Rotas Privadas */}
        <Route element={<PrivateRoute />}>
          {privateRoutes.map(({ path, component: Component }) => (
            <Route
              key={path}
              path={path}
              element={
                <Suspense fallback={<Loading />}>
                  <Component />
                </Suspense>
              }
            />
          ))}
        </Route>

        {/* Rotas Administrativas */}
        <Route element={<AdminRoute />}>
          {adminRoutes.map(({ path, component: Component }) => (
            <Route
              key={path}
              path={path}
              element={
                <Suspense fallback={<Loading />}>
                  <Component />
                </Suspense>
              }
            />
          ))}
        </Route>
      </Routes>
    </Suspense>
  )
} 